import { ShortDateWithHoursAndMinutesFormat, ShortDateWithTimeFormat } from './date'
import dayjs from 'dayjs'

export function formatToDate(
  date: string | Date | number,
  params?: { utc?: boolean; showSeconds?: boolean; timezone?: string },
) {
  const format = params?.showSeconds ? ShortDateWithTimeFormat : ShortDateWithHoursAndMinutesFormat

  if (params?.utc) {
    return dayjs.utc(date).format(format)
  }

  if (params?.timezone && date) {
    // Convert the date to the specified timezone
    return dayjs(date).tz(params.timezone).format(format)
  }

  return dayjs(date).format(format)
}

/**
 * App version reported in the device descriptor's `appVersion` field.
 *
 * TODO(device): wire to a real source (package.json `version` import or a
 * REACT_APP_VERSION build var). Returns '' for now so the login device body
 * compiles and the IUserDevice shape stays intact without committing to one.
 */
export function getAppVersion(): string {
  return ''
}